export default function Card({ children, style, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: "linear-gradient(135deg,#0f172a,#1e293b)",
        border: "1px solid #1e3a5f",
        borderRadius: 16,
        padding: 20,
        ...(style || {}),
      }}
    >
      {children}
    </div>
  );
}
